export const CONTACT_TICKET_STRINGS: Record<string, [string, string, string]> = {
  'tc.cloudFlightDesc': [
    '使用手機或 Email，查看航班時間與登船資訊。',
    'Use your phone number or email to view sailing and boarding information.',
    '電話番号またはメールで出発時刻と乗船情報を確認できます。',
  ],
  'tc.cloudReview': [
    '此申請需人工審核，實際退款金額以審核結果為準。',
    'Staff review is required. The final refund depends on the review.',
    '係員の審査が必要です。最終的な払戻額は審査結果に従います。',
  ],
  'tc.qr': ['QR Code 掃描', 'Scan QR code', 'QR コードを読み取る'],
  'tc.manual': ['手機／Email 查詢', 'Phone / Email lookup', '電話番号／メールで検索'],
  'tc.phone': ['手機查詢', 'Phone', '電話番号'],
  'tc.phoneHint': [
    '請選擇國碼，並輸入購票時填寫的完整手機號碼。',
    'Select the country code and enter the full mobile number used for purchase.',
    '国番号を選び、購入時の携帯電話番号をすべて入力してください。',
  ],
  'tc.email': ['Email 查詢', 'Email', 'メール'],
  'tc.emailLabel': [
    '購票時填寫的 Email（必填）',
    'Email used for purchase (required)',
    '購入時のメールアドレス（必須）',
  ],
  'tc.code': ['票券號碼（必填）', 'Ticket number (required)', 'チケット番号（必須）'],
  'tc.codeHint': [
    '請填寫票券上的完整號碼，例如 TKT-20261027-12AFB1。',
    'Enter the full number on your ticket, e.g. TKT-20261027-12AFB1.',
    'チケットの完全な番号を入力してください。例：TKT-20261027-12AFB1。',
  ],
  'tc.hint': [
    '請輸入購票時填寫的手機或 Email。',
    'Enter the phone number or email used for purchase.',
    '購入時の電話番号またはメールアドレスを入力してください。',
  ],
  'tc.refundHint': [
    '請輸入購票時的手機或 Email，並填寫要退票的票券號碼。',
    'Enter the purchase contact and the number of the ticket to refund.',
    '購入時の連絡先と払い戻すチケット番号を入力してください。',
  ],
  'tc.search': ['查詢', 'Search', '検索'],
  'tc.again': ['重新輸入', 'New search', '再入力'],
  'tc.available': [
    '可掃描票券，或使用手機／Email 查詢',
    'Scan a ticket or search by phone / email',
    'チケットを読み取るか、電話番号／メールで検索',
  ],
  'tc.more': ['載入更多', 'Load more', 'さらに表示'],
  'tc.select': ['查看內容', 'View details', '詳細を見る'],
  'tc.results': ['查詢結果', 'Search results', '検索結果'],
  'tc.empty': [
    '查無票券，請確認購票時填寫的聯絡資料。',
    'No tickets found. Check the contact used for purchase.',
    'チケットが見つかりません。購入時の連絡先をご確認ください。',
  ],
  'tc.mismatch': [
    '資料不符，請確認聯絡資料與票券號碼後再試。',
    'Details do not match. Check the contact and ticket number.',
    '連絡先とチケット番号が一致しません。ご確認ください。',
  ],
  'tc.invalid': [
    '請確認輸入格式後再試。',
    'Check the input format and try again.',
    '入力形式をご確認ください。',
  ],
  'tc.failed': [
    '暫時無法查詢，請稍後再試。',
    'Unable to search. Please try again.',
    '検索できません。もう一度お試しください。',
  ],
  'tc.masked': [
    '票券號碼已部分隱藏；辦理退票請使用原票券上的完整號碼。',
    'Ticket numbers are masked. Use the full number on your original ticket for a refund.',
    '番号の一部は非表示です。払い戻しには元のチケットの完全な番号をご使用ください。',
  ],
};
